var jsGlobal = (function($, window) {

  var o = {};
  o = {
    navExpand: false,
    searchExpand: false,
    windowW: window.innerWidth,
    smallScreen: window.innerWidth < 642,
    mediumScreen: window.innerWidth < 720,
    touchEvents: Modernizr.touchevents,
    hasParent: function(el, id) {
      if (!el) return false;
      var elem = el.target || el.srcElement || el || false;
      while (elem && elem.id !== id) {
        elem = elem.parentNode || false;
      }
      return (elem !== false);
    },
    updateCart: function() {
      var tot = document.getElementById('hcTotal');
      var count = document.getElementById('hcCount');
      var hc = document.getElementById('headerCart');
      var hasItem = hc.getAttribute('data-hasitem');
      var parent = document.getElementById('hciList');

      Shopify.getCart(function(cart) {
        var i;

        count.textContent = cart.item_count;
        while (parent.firstChild) {
          parent.removeChild(parent.firstChild);
        }
        tot.innerHTML = Shopify.formatMoney(cart.total_price, "<span class='money'>${{amount}}</span>");
        if (cart.item_count > 0) {
          if (hasItem < 1) { hc.setAttribute('data-hasitem', '1') }
          
          for (i = 0; i<cart.items.length; i++) {
            var a = document.createElement('li');
            a.setAttribute('data-cartid', cart.items[i].id);
            var b = document.createElement('a');
            b.setAttribute('href', cart.items[i].url)
            b.setAttribute('title', cart.items[i].product_title)
            var titLen = cart.items[i].product_title.length;
            if ( titLen > 24) {
              var trunc = cart.items[i].product_title.substring(0, 24) + " ...";
              b.textContent = trunc;
            } else {
              b.textContent = cart.items[i].product_title;
            }
            var c = document.createElement('div');
            c.setAttribute('class', 'hci-group group')
            var d = document.createElement('div');
            d.setAttribute('class', 'hci-img')
            var e = document.createElement('img');
            e.setAttribute('src', Shopify.resizeImage(cart.items[i].image, 'small'))
            e.setAttribute('alt', cart.items[i].product_title);
            d.appendChild(e)
            var f = document.createElement('div');
            f.setAttribute('class', 'hci-detail')
            if (cart.items[i].variant_title) {
              var g = document.createElement('span');
              g.textContent = cart.items[i].variant_title;
              f.appendChild(g);
            }
            var h = document.createElement('p');
            h.setAttribute('class', 'hci-sum');
            var k = document.createElement('span');
            k.textContent = cart.items[i].quantity + ' x ';
            h.appendChild(k)
            var l = document.createElement('span');
            l.innerHTML = Shopify.formatMoney(cart.items[i].price, "<span class='money'>${{amount}}</span>");
            h.appendChild(l)
            var m = document.createElement('button');
            m.setAttribute('type', 'button');
            m.setAttribute('class', 'hci-remove');
            m.setAttribute('title', 'Remove');
            m.textContent = 'x';

            // f.appendChild(g)
            f.appendChild(h)

            c.appendChild(b)
            c.appendChild(d)
            c.appendChild(f)
            c.appendChild(m)

            a.appendChild(c)

            parent.appendChild(a)

          }
        }
      });
    }
  }

  // helpers
  var wait = (function() {
    var intrvl = {};
    var removeListener = function(sel) {
      if (intrvl[sel]) {
        window.clearInterval(intrvl[sel]);
        intrvl[sel] = null;
      }
    };
    var f = 'waiting.f';
    $.fn.waiting = function(handler, run, child) {
      var selector = this.selector;
      var $this = $(selector);
      var $elements = $this.not(function() { return $(this).data(f); });
      if (handler === 'remove') {
        removeListener(selector);
      }
      else {
        $elements.each(handler).data(f, true);
        if (run && $this.length) {
          removeListener(selector);
        }
        else if (!child) {
          intrvl[selector] = window.setInterval(function () {
            $this.waiting(handler, run, true);
          }, 500);
        }
      }
      return $this;
    };
  })();

  // Header Navigation left
  var HNL = {};
  HNL = {
    button: document.getElementById('hnlButton'),
    scope: document.getElementById('hnlContent'),
    bodyDoc: document.getElementById('theBody'),
    open: false,
    level: 0,
    tasks: function() {
      var self = this;

      var l = self.scope.querySelectorAll('.hnl-layer');
      self.layers = Array.prototype.slice.call(l);

      var s = self.scope.querySelectorAll('.hnl-layer-deep');
      self.subs = Array.prototype.slice.call(s);

      var b = self.scope.querySelectorAll('.hnl-layer-back')
      self.backs = Array.prototype.slice.call(b);

      self.dataLevel()
      self.events();
    },
    dataLevel: function() {
      var self = this;
      self.layers.forEach(function(el, idx) {
        el.setAttribute('data-level', self.getDepth( el, self.scope.id, 'hnl-layer' ))
      })
    },
    getDepth: function( el, id, parentclass, cnt ) {
      var self = this;
      cnt = cnt || 0;
      if ( el.id.indexOf( id ) >= 0 ) return cnt;
      if( $(el).hasClass(parentclass) ) {
        ++cnt;
      }
      return el.parentNode && self.getDepth( el.parentNode, id, parentclass, cnt );
    },
    events: function() {
      var self = this;

      self.button.addEventListener('click', function(ev) {
        ev.stopPropagation();
        if (self.open) {
          self.closeNav();
          self.bodyDoc.setAttribute('data-leftnavopen', '0')
        } else {
          self.openNav();
          self.bodyDoc.setAttribute('data-leftnavopen', '1');
          // close nav body click
          document.addEventListener('click', function( e) {
            if( self.open && !jsGlobal.hasParent( e.target, self.scope.id )) {
              self.closeNav();
              self.bodyDoc.setAttribute('data-leftnavopen', '0')
            }
          });
          // close button inside nav
          var close = document.getElementById('hnlClose');
          close.addEventListener('click', function(ev) {
            ev.stopPropagation();
            self.closeNav();
            self.bodyDoc.setAttribute('data-leftnavopen', '0')
          })
          // close other nav open
          if (jsGlobal.navExpand || jsGlobal.searchExpand) {
            var ids =  ['#hsContent', '#huTarget', '#hcTarget'];
            var n = document.querySelectorAll(ids);
            var nav = Array.prototype.slice.call(n);
            nav.forEach(function(el, idx) {
              el.setAttribute('data-expand', '0');
              jsGlobal.navExpand = false;
              jsGlobal.searchExpand = false;
            })
          }
        }
      });

      // open sub level
      self.subs.forEach(function(el, idx) {
        var subLayer = el.querySelector('.hnl-layer');
        var anchor = el.querySelector('a');
        if ( subLayer ) {
          anchor.addEventListener( 'click', function( e ) {
            e.preventDefault();
            var level = self.closest( el, 'hnl-layer' ).getAttribute( 'data-level' );
            if ( self.level <= level ) {
              e.stopPropagation();
              self.openNav(subLayer)
            }
          } );
        }
      });

      // close sub level
      self.backs.forEach(function(el, idx) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          var level = self.closest( el, 'hnl-layer' ).getAttribute( 'data-level' );
          if( self.level <= level ) {
            e.stopPropagation();
            self.level = level - 1;
            self.level === 0 ? self.closeNav() : self.closeSubNav();
          }
         })
      })
    },
    closest: function( el, classname ) {
      var self = this;
      if( $(el).hasClass(classname) ) {
        return el;
      }
      return el.parentNode && self.closest( el.parentNode, classname );
    },
    closeSubNav : function() {
      var self = this;
      self.toggleLevels();
    },
    closeNav: function() {
      var self = this;
      self.level = 0;
      self.scope.setAttribute('data-opencontent', '0');
      self.toggleLevels();
      self.open = false;
    },
    toggleLevels: function() {
      var self = this;
      var i = 0;
      var len = self.layers.length;
      for( ; i< len; ++i ) {
        var elLevel = self.layers[i];
        if( elLevel.getAttribute('data-level') >= self.level + 1 ) {
          elLevel.setAttribute('data-openlayer', '0')
        }
      }
    },
    openNav: function(subLevel) {
      var self = this;
      ++self.level;

      if( self.level === 1 ) {
        self.scope.setAttribute('data-opencontent', '1')
        self.open = true;
      }
      if( subLevel ) {
        // reset transform
        self.setTransform('', subLevel);
        // reset translate value that have same level depth and not open
        var i = 0;
        var len = self.layers.length;
        for(; i < len; ++i ) {
          var levelEl = self.layers[i];
          var dataOpen = levelEl.getAttribute('data-openlayer');
          if( levelEl != subLevel && dataOpen === '0' ) {
            self.setTransform( 'translateX(-100%)', levelEl );
          }
        }
        subLevel.setAttribute('data-openlayer', '1')
      }
      self.layers[0].setAttribute('data-openlayer', '1')
    },
    setTransform : function(val, el) {
      var self = this;
      el = el || self.scope;
      el.style.WebkitTransform = val;
      el.style.MozTransform = val;
      el.style.transform = val;
    }

  }

  // header search
  var HS = {};
  HS = {
    searchInput: document.getElementById('hsInput'),
    searchContent: document.getElementById('hsContent'),
    tasks: function() {
      var self = this;

      self.searchInput.addEventListener('click', function(ev) {
        self.searchContent.setAttribute('data-expand', '1');
        jsGlobal.searchExpand = true;
      });
      self.searchInput.addEventListener('mouseenter', function(ev) {
        self.searchContent.setAttribute('data-expand', '1');
      });
      self.searchInput.addEventListener('mouseleave', function(ev) {
        if(jsGlobal.searchExpand) {
          return;
        } else {
          self.searchContent.setAttribute('data-expand', '0');
          jsGlobal.searchExpand = false;
        }
      });
      document.addEventListener('click', function(ev) {
        ev.stopPropagation();
        if(jsGlobal.searchExpand && !jsGlobal.hasParent( ev.target, self.searchContent.id )) {
          self.searchContent.setAttribute('data-expand', '0')
          jsGlobal.searchExpand = false;
        }
      });
    }
  }

  // header nav tasks
  var HNT = {};
  HNT = {
    targets: ['#huTarget', '#hcTarget'],
    $cartScope: $('#hcTarget'),
    current: -1,
    tasks: function() {
      var self = this;

      self.content = document.querySelectorAll(self.targets);
      self.contents = Array.prototype.slice.call(self.content);


      self.expand();
      self.removeCartItem();
    },
    expand: function() {
      var self = this;
      self.contents.forEach(function(el, idx) {
        var i = self.contents.indexOf(el);
        var hide = function(current) {
          var current = current || self.content[i];
          el.setAttribute('data-expand', '0')
          jsGlobal.navExpand = false;
        }
        var hideAll = function() {
          self.current = -1;
          jsGlobal.navExpand = false;
        }
        var hideGlobal = function() {
          document.addEventListener('click', function(ev) {
            ev.stopPropagation();

            if (!jsGlobal.hasParent( ev.target, 'hcTarget')&&!jsGlobal.hasParent( ev.target, 'huTarget') ) {
              el.setAttribute('data-expand', '0');
              jsGlobal.navExpand = false;
            }
          })
        }

        var trigger = el.parentNode.firstElementChild;
        trigger.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var ex = el.getAttribute('data-expand')

          if(el) {
            if(ex === '1') {
              hide(el)
              hideAll();
            } else {
              if(self.current !== -1) {
                hide();
                $(self.contents).attr('data-expand', '0');
              }
              self.current = i;
              el.setAttribute('data-expand', '1');
              if (jsGlobal.searchExpand) {
                HS.searchContent.setAttribute('data-expand', '0');
                jsGlobal.searchExpand = false;
              }
              jsGlobal.navExpand = true;
            }
          } else {
            if(self.current !== -1) {
              hide();
              hideAll();
            }
          }
          if(jsGlobal.navExpand) {
            hideGlobal();
          }
        });
      })
    },
    removeCartItem: function() {
      var self = this;
      var count = document.getElementById('hcCount');
      var hCart = document.getElementById('headerCart');
      var tot = document.getElementById('hcTotal')

      self.$cartScope.on('click', '.hci-remove', function(ev) {
        ev.stopPropagation();

        ev.target.setAttribute('disabled', '');
        var parent = ev.target.parentNode;
        var grand = parent.parentNode;
        var cartid = grand.getAttribute('data-cartid');
        Shopify.removeItem(cartid, function(cart) {
          while (grand.firstChild) {
            grand.removeChild(grand.firstChild);
          }
          count.textContent = cart.item_count;
          tot.innerHTML = Shopify.formatMoney(cart.total_price, "<span class='money'>${{amount}}</span>");
          if (cart.item_count === 0) {
            hCart.setAttribute('data-hasitem', '0')
          }
          ev.target.setAttribute('disabled', '')
        });
      })
    }
  }

  // product reviews
  var REV = {};
  REV = {
    tasks: function() {
      $('.card-review-ori .spr-badge').waiting(function(idx, el) {

        var ids = el.parentNode.getAttribute('data-prodid');
        var rating = el.getAttribute('data-rating');
        var ratings = function (n) {    
          return +(Math.round(n + "e+1")  + "e-1");
        }
        var countSrc = el.parentNode.querySelector('.spr-badge-caption').textContent;
        var countNum = countSrc.match(/\d/g).join("");
        var count = "( " + countNum + " )";
        var countBlank = countNum;

        var w = el.parentNode.parentNode.querySelector('.card-review-wrapper')
        var wids = w.getAttribute('data-prodid');
        var r = el.parentNode.parentNode.querySelector('.card-review-wrapper > .card-review-rating');
        var c = el.parentNode.parentNode.querySelector('.card-review-wrapper > .card-review-count');
        var num = parseFloat(rating)
        if (num === 0.0) {
          w.setAttribute('data-star', 'blank')
        } else if ( (num > 0.0) && (num < 4.0) ) {
          w.setAttribute('data-star', 'half')
        } else if (num >= 4.0) {
          w.setAttribute('data-star', 'full')
        }
        if(ids === wids) {
          w.setAttribute('data-loaded', '1')
          w.setAttribute('data-rating', ratings(rating));
          w.setAttribute('data-count', countBlank);
          r.textContent = ratings(rating);
          if (num == 0.0) {
            c.textContent = countBlank;
          } else {
            c.textContent = count;
          }
          
        }
      });
    }
  }



  HNL.tasks();
  HS.tasks();
  HNT.tasks();
  REV.tasks();

  return o;

})(jQuery, window);